import React, { useState, useEffect } from 'react';
import { TESTIMONIALS as FALLBACK_TESTIMONIALS } from '../mock';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';

const Testimonials = () => {
  const reviews = FALLBACK_TESTIMONIALS;
  const [i, setI] = useState(0);

  const n = reviews.length;
  const t = reviews[i] || reviews[0];
  if (!t) return null;

  return (
    <section className="py-24 lg:py-32 bg-[#FFFFFF]">
      <div className="max-w-[1300px] mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <h2 className="font-serif text-3xl lg:text-4xl text-[#1a1a1a]">Your love keeps us going</h2>
        </div>
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="aspect-[4/5] overflow-hidden bg-[#FFFFFF]">
            <img src={t.img} alt={t.name} className="w-full h-full object-cover transition-opacity duration-700" key={t.img} />
          </div>
          <div className="flex flex-col">
            <Quote size={40} strokeWidth={1} className="text-[#999959]" />
            <p className="font-serif text-2xl lg:text-3xl leading-relaxed text-[#1a1a1a] mt-6">“{t.quote}”</p>
            <div className="mt-8">
              <div className="font-serif text-xl text-[#1a1a1a]">{t.name}</div>
              <div className="text-[11px] tracking-widest-2 uppercase text-[#7a6a54] mt-1">{t.location}</div>
            </div>
            {n > 1 && (
              <div className="flex items-center gap-4 mt-10">
                <button onClick={() => setI((i - 1 + n) % n)} className="w-10 h-10 rounded-full border border-[#1a1a1a] flex items-center justify-center hover:bg-[#1a1a1a] hover:text-[#FFFFFF] transition-colors"><ChevronLeft size={16} strokeWidth={1.4} /></button>
                <div className="text-[12px] tracking-widest-2 uppercase text-[#7a6a54]">{String(i+1).padStart(2,'0')} / {String(n).padStart(2,'0')}</div>
                <button onClick={() => setI((i + 1) % n)} className="w-10 h-10 rounded-full border border-[#1a1a1a] flex items-center justify-center hover:bg-[#1a1a1a] hover:text-[#FFFFFF] transition-colors"><ChevronRight size={16} strokeWidth={1.4} /></button>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;

